import { useContext, useEffect, useState } from 'react';

import { ROLES } from '../config';
import AuthContext from '../Contexts/AuthProvider';

export const roleNameEnum = {
    admin: 'admin',
    client: 'client',
    expert:'expert',
    esn: 'esn'
};

const useRole = () => {
    // ? the will return the role intutule
    const { auth } = useContext(AuthContext);
    const [role, setRole] = useState('');
    useEffect(() => {
        if (auth?.roles == ROLES.Admin) {
            setRole(roleNameEnum.admin);
        } else if (auth?.roles == ROLES.Client) {
            setRole(roleNameEnum.client);
        } else if (auth?.roles == ROLES.Expert) {
            setRole(roleNameEnum.expert);
        } else if (auth?.roles == ROLES.Esn) {
            setRole(roleNameEnum.esn);
        }
    }, [role]);
    return role;
};

export default useRole;